export const cloneArray = <T extends object>(n: number, sample: T[]) => {
  return Array.from({ length: n }, (_, i) => ({
    ...sample[i % sample.length],
    id: `${i}`,
  })) as (T & { id: string })[];
};

export const cloneArrayWithId = <T extends object>(sample: T[]) =>
  cloneArray(sample.length, sample);

export const genArrayWithId = (n: number) => {
  return Array.from({ length: n }, (_, i) => ({
    id: `${i}`,
  })) as { id: string }[];
};

export const mapArrayToRecord = <T extends object>(
  array: T[],
  getId: (item: T) => string
) => {
  return array.reduce(
    (acc, item) => {
      acc[getId(item)] = item;
      return acc;
    },
    {} as Record<string, T>
  );
};
